import http from "@/http-common";

class ResultDataService {

  getEventResult(ekpDataId) {
    return http.get(`/event/${ekpDataId}/result`)
    .catch((e) => {
      console.log(e.message)
      throw e
    })
  }

  saveResult(ekpDataId, items) {
    return http.post('/event/' + ekpDataId + '/result', items)
    .catch((e) => {
      console.log(e.message)
      throw e
    })
  }

}

export default new ResultDataService();
